import ReactDOM from "react-dom/client";
import App from "./app/App";
import { Provider } from "react-redux";
import store from "./shared/redux/store";
import { initialization } from "./shared/scripts";
import { IntlProvider } from "react-intl";
import { languages } from "./app/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

initialization().then((user) => {
  window.user = user;
  const locale = user.locale === "ru" ? "ru" : "en";
  const language = languages[locale];

  root.render(
    <Provider store={store}>
      <IntlProvider locale={locale} messages={language}>
        <App />
      </IntlProvider>
    </Provider>,
  );
});
